const state = {

}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js